import { get, filter, includes } from 'lodash';
import { connect } from 'react-redux';

import GeofencingShopSelector from 'components/GeofencingShopSelector';
import { GEOFENCING_SHOPS } from 'constants/geofencing';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';
import Settings from 'utils/Settings';

const mapStateToProps = state => {
  const isOpen = get(state, ['app', 'modal']) === MODAL_TYPES.GEOFENCING_SHOP_SELECTOR;
  const alternativeShopID = get(state, ['geofencing', 'alternativeShopID'], '');
  const currentShopID = Settings.shopID;
  const remainingShops = filter(
    GEOFENCING_SHOPS,
    (_, shopID) => !includes([alternativeShopID, currentShopID], shopID)
  );

  return {
    isOpen,
    alternativeShopID,
    currentShopID,
    remainingShops,
  };
};

const mapDispatchToProps = dispatch => ({
  setShopSelection: shopID => dispatch(actions.setGeofencingShopSelection(shopID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeofencingShopSelector);
